import ParkingContainer from 'component/parking/ParkingContainer';

export default function ParkingPage() {
  return <ParkingContainer />;
}
